import { dateOptions } from 'coreOld/constants';
import { FilterField } from 'coreOld/enums';
import { useGetRanks } from 'system/hooks';
import { getUserStatusOptions } from 'system/utils';

import { UsersTabs } from './constants';

const usersConfig = [
  {
    name: 'query',
    type: FilterField.SEARCH,
    minWidth: 300,
    flex: 100,
  },
  {
    name: 'ranks',
    type: FilterField.SELECT,
    props: {
      useGetOptions: useGetRanks,
      getValue: (opt) => opt?.rankId,
      getLabel: (opt) => opt?.rankName,
      placeholder: 'Ranks',
      isMulti: true,
    },
    width: 300,
  },
  {
    name: 'created_at_date_range',
    type: FilterField.DATE,
    width: 300,
    props: {
      options: dateOptions,
    },
  },
  {
    name: 'status',
    type: FilterField.SELECT,
    width: 300,
    props: {
      options: getUserStatusOptions(),
    },
  },
];

const ranksConfig = [
  {
    name: 'query',
    type: FilterField.SEARCH,
    flex: 100,
    minWidth: 300,
  },
  {
    name: 'add',
    type: FilterField.ADD,
    width: 200,
    height: 61,
  },
];

export const filtersConfig = (tab) => {
  if (tab.title === UsersTabs.MANAGE_USERS) {
    return usersConfig;
  }

  return ranksConfig;
};
